// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1w7gZ","dragIcon":"SortableItem_dragIcon__173xb","disabled":"SortableItem_disabled__1BtFg"};